<script setup>
  import { useFlashStore } from '../../stores/flash';
  const flashStore = useFlashStore();
</script>


<template>
  <v-snackbar-queue v-model="flashStore.messages" closable location="bottom end">
    <template v-slot:actions="{ props }">
      <v-btn
        aria-label="Close"
        icon="$close"
        size="small"
        variant="text"
        v-bind="props"
      ></v-btn>
    </template>
  </v-snackbar-queue>
</template>
